<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Forgot Password v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <!-- logo -->
          <!-- <vuexy-logo /> -->
          <img
            style="width: 100px;"
            src="../../assets/images/logo/LogoVls.png"
          >

          <h2 class="brand-text text-primary ml-1" />
        </b-link>

        <b-card-title class="mb-1">
          <h5
            class="text-h5 font-weight-semibold mb-1"
            _msthash="1600859"
            _msttexthash="25596662"
          > Verificar
            seu e-mail ✉️ </h5>
        </b-card-title>
        <b-card-text
          class="mb-2"
          style="font-size: 12px;"
        >
          As instruções para a redefinição de senha foram enviadas para seu e-mail
        </b-card-text>
        <div class="col d-flex justify-content-center">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            :to="{ name: 'auth-login' }"
            variant="primary"
          >Voltar e fazer login</b-button>
        </div>
        <b-card-text class="text-center mt-2">
          <span> Não recebeu o e-mail? </span>
          <b-link :to="{ name: 'auth-reset-password-v1' }">
            Reenviar
          </b-link>
        </b-card-text>
      </b-card>
      <!-- /Forgot Password v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BCard, BLink, BCardText, BCardTitle, BFormGroup, BFormInput, BForm, BButton,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import PassWordService from '@/services/RedefirSenha'

export default {
  components: {
    VuexyLogo,
    BCard,
    BLink,
    BCardText,
    BCardTitle,
    BFormGroup,
    BFormInput,
    BButton,
    BForm,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      EmailData: JSON.parse(localStorage.getItem('EmailData')),
      userEmail: '',
      // validation
      required,
      email,
    }
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
